// src/components/common/DocsHandoffSnackbar.js
//
// Bottom-right notice shown when the documentation bounced the user here to
// pick up a fresh sign-in cookie and the documentation server then could not
// see that cookie (AuthContext's docsHandoff). Without this the app would
// send the user straight back and the two sides would bounce each other
// forever. Try again rewrites the cookie and asks the server once more;
// Dismiss forgets the hand-off.

import React from 'react';
import { Alert, Button, IconButton, Snackbar } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useAuth } from '../../contexts/AuthContext';

function DocsHandoffSnackbar() {
  const { docsHandoff, retryDocsHandoff, dismissDocsHandoff } = useAuth();

  const message = docsHandoff && docsHandoff.status === 'unreachable'
    ? 'Decode could not reach the documentation to confirm your sign-in. Check your connection and try again.'
    : `The documentation could not confirm your sign-in. Your browser appears to be blocking cookies for ${window.location.host}; allow them for this site and try again.`;

  return (
    <Snackbar
      open={Boolean(docsHandoff)}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'right' }}
    >
      {/* As in UpdateAvailableSnackbar: with `action` given, Alert drops the close
          button `onClose` would render, so Dismiss is part of the action. */}
      <Alert
        severity="warning"
        variant="filled"
        action={(
          <>
            <Button color="inherit" size="small" onClick={retryDocsHandoff}>
              Try again
            </Button>
            <IconButton
              aria-label="Dismiss"
              color="inherit"
              size="small"
              onClick={dismissDocsHandoff}
              sx={{ ml: 0.5 }}
            >
              <CloseIcon fontSize="small" />
            </IconButton>
          </>
        )}
        sx={{ alignItems: 'center', maxWidth: 560 }}
      >
        {message}
      </Alert>
    </Snackbar>
  );
}

export default DocsHandoffSnackbar;
